<script setup lang="ts">
</script>

<template>
    <section class="flex justify-center items-center w-screen h-full bg-cover lg:bg-[top-center] bg-[left] bg-no-repeat" style="background-image: url(/pagesImages/semi-abierto-BLANCO.webp); ">
        <div class="lg:flex justify-between w-full max-w-4xl lg:max-w-[1200px] items-center">
            <div class="flex flex-col lg:justify-start justify-center items-center lg:items-start lg:w-[50%] w-full my-20 text-justify md:px-4 px-12 text-gray-800">
                <h2>
                    <p>
                        <span class="block text-hwine leading-tight text-left text-[28px]" style="">M&eacute;todo Educativo</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-hwine leading-tight text-left font-serif mb-2 text-[42px]">Semi-Abierto</span>
                    </p>
                </h2>
                <p class="mb-4 text-justify hyphens-auto">
                    • Tres horas al día de clases presenciales, una vez por semana.
                </p>
                <p class="mb-4 text-justify hyphens-auto">
                    • Curso con duración de ocho trimestres.
                </p>
                <p class="mb-4 text-justify hyphens-auto">
                    • Preparación para certificaciones Cambridge, según el nivel cursado.
                </p>
                <p class="mb-4 text-justify hyphens-auto">
                    • Es obligatorio presentarse en algunos de nuestros Campus el día y hora establecidos para responder los exámenes de nivelación.
                </p>
                <p class="mb-4 text-justify hyphens-auto">
                    En English Kingdom, el nivel de ingreso se determina a través de un examen de colocación, el cual permite evaluar las competencias lingüísticas y asignar al estudiante al nivel correspondiente: Básico, Intermedio o Avanzado. Además, este proceso facilita la identificación de la certificación más adecuada según el nivel de dominio del idioma.
                </p>
                <router-link to="/contacto">
                    <div class="flex items-center justify-center w-[140px] h-[35px] hover:bg-hwine bg-hgold text-white text-lg transition duration-300 ease-in-out">
                        <span>Inscr&iacute;bete</span>
                    </div>
                </router-link>
            </div>
        </div>
    </section>
</template>

<style scoped>

</style>